import React, { useEffect, useState, useRef } from "react";
import { Button, Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  ModalBodyBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../../features/RadConnStyle";
import styled from "styled-components";

import BoostrapTable from "react-bootstrap-table-next";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";
import { GetConfirmTitle } from "../../components/ConfirmDialog";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { GetCreateTable } from "../../../core/Helper2";

export default function GoodsCategory(props) {
  // ********** Variable **********
  const [data, setData] = useState([]);
  const [reload, setReload] = useState(true);
  const objREF = useRef([]);

  useEffect(() => {
    if (reload || props.showCategory) {
      loadList();
      setReload(false);
    }
  }, [reload, props.showCategory]);

  // ********** RELOAD *********
  const loadList = () => {
    axios
      .post(
        process.env.REACT_APP_API + "api/goods/list-goods-category",
        { text: "ok" },
        HttpJsonHeader
      )
      .then((response) => {
        setData(response.data.rows);
      })
      .catch((err) => alert(err));
  };

  // ********** ADDNEW **********
  const doAddNew = () => {
    let ooo = objREF.current;
    if (ooo.GoodCateName.value === "") return;

    let saveData = {
      GoodCateId: -1,
      GoodCateName: ooo.GoodCateName.value,
      Flag_Buy: ooo.Flag_Buy.checked ? "y" : "n",
      Flag_Modality: ooo.Flag_Modality.checked ? "y" : "n",
      Flag_Sell: ooo.Flag_Sell.checked ? "y" : "n",
      Flag_InvoiceHide: ooo.Flag_InvoiceHide.checked ? "y" : "n",
      Flag_Service: ooo.Flag_Service.checked ? "y" : "n",
      Flag_Sn: ooo.Flag_Sn.checked ? "y" : "n",
      Flag_Stock: ooo.Flag_Stock.checked ? "y" : "n",
      Flag_Tool: ooo.Flag_Tool.checked ? "y" : "n",
      CreatedBy: props.user.userid,
    };
    axios
      .post(
        process.env.REACT_APP_API + "api/goods/goods-category-save",
        saveData,
        HttpJsonHeader
      )
      .then((res) => {
        setReload(true);
        ooo.GoodCateName.value = "";
        ooo.Flag_Buy.checked = false;
        ooo.Flag_Modality.checked = false;
        ooo.Flag_Sell.checked = false;
        ooo.Flag_InvoiceHide.checked = false;
        ooo.Flag_Service.checked = false;
        ooo.Flag_Sn.checked = false;
        ooo.Flag_Stock.checked = false;
        ooo.Flag_Tool.checked = false;
      })
      .catch((err) => console.log(err));
  };

  //  ********** Update Data **********
  const beforeSaveCell = (oldValue, newValue, row, column, done) => {
    if (oldValue === newValue) {
      done(false);
      return;
    }

    let saveData = row;
    saveData[column.dataField] = newValue;
    saveData = { ...saveData, UpdatedBy: props.user.userid };

    axios
      .post(
        process.env.REACT_APP_API + "api/goods/goods-category-save",
        saveData,
        HttpJsonHeader
      )
      .then((res) => {
        // setReload(true);
        done(true);
      })
      .catch((err) => console.log(err));
  };

  // ********** Delete **********
  const popupDelete = (row) => {
    props.setShowConfirm(true);
    let data = {
      GoodCateId: row.GoodCateId,
      DeletedBy: props.user.userid,
    };

    props.setConfirmAction({
      title: GetConfirmTitle("DELETE"),
      data: row,
      action: (row) => {
        axios
          .post(
            process.env.REACT_APP_API + "api/goods/goods-category-delete",
            data,
            HttpJsonHeader
          )
          .then((res) => {
            setReload(true);
          })
          .catch((err) => console.log(err));
      },
    });
  };

  const removeBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>ลบ</Tooltip>}
        >
          <Button
            variant="danger"
            className="info-button"
            onClick={() => {
              popupDelete(row);
            }}
          >
            <AiOutlineDelete />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };

  const headerBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>บันทึก</Tooltip>}
        >
          <Button
            variant="info"
            className="info-button"
            onClick={() => doAddNew()}
          >
            <AiOutlinePlus />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };

  // checkbox change handle
  const CheckedChange = (e, column, colIndex) => {
    //   alert(e);
    //   objREF.current[column.dataField] = e.target.value;
    let xxx = e;
  };

  //  ********** Field Style **********

  const fieldStyle = () => {
    return {
      border: "none",
      padding: "2px 5px 2px 5px",
      color: "var(--table-text-color)",
      alignItems: "center",
      justifyContent: "center",
    };
  };
  const editorCheckBox = { type: Type.CHECKBOX, value: "y:n" };
  const headerColStyle = () => {
    return {
      justifyContent: "center",
      alignItems: "center",
      verticalAlign: "middle",
      //  border:'1px solid',
      border: "none",
      fontSize: "15px",
      color: "white",
      backgroundImage: "linear-gradient(#212122,  #38383a, #2d2d2e)",
    };
  };
  const headerFlagStyle = () => {
    return { ...headerColStyle(), width: "50px" };
  };
  const checkboxFormat = (col, row, rowIndex) => {
    return (
      <input
        type="checkbox"
        style={{ height: "20px", width: "20px" }}
        checked={col === "y" ? true : false}
      />
    );
  };
  const editCellStyle = { textAlign: "center" };
  const editorCheckBoxStyle = (cell, row, rowIndex, colIndex) => {
    return { width: "20px", height: "20px" };
  };

  const headerCheckBox = (column, colIndex, { sortElement, filterElement }) => {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ height: "50px" }}>{column.text}</div>
        <div>
          <input
            type="checkbox"
            onChange={(e) => CheckedChange(e, column, colIndex)}
            className="checkbox-20"
            // ref={(el)=>{objREF.current[colIndex]=el}}
            ref={(el) => {
              objREF.current[column.dataField] = el;
            }}
          />
        </div>
      </div>
    );
  };

  const headerTextBox = (column, colIndex, { sortElement, filterElement }) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "5px 0 0 0",
        }}
      >
        <div style={{ height: "45px" }}>{column.text}</div>
        <div>
          <input
            type="text"
            className="textbox-40h"
            ref={(el) => {
              objREF.current[column.dataField] = el;
            }}
          />
        </div>
      </div>
    );
  };

  //  ********** Columns  **********
  const columns = [
    {
      dataField: "GoodCateName",
      text: "ประเภทสินค้าบริการ",
      align: "left",
      style: () => {
        return { ...fieldStyle(), paddingLeft: "25px" };
      },
      headerStyle: () => {
        return { ...headerColStyle(), minWidth: "200px" };
      },
      headerFormatter: headerTextBox,
    },

    {
      dataField: "Flag_Buy",
      text: "ซื้อ",
      align: "center",
      style: fieldStyle,
      headerStyle: headerFlagStyle,
      editorStyle: editorCheckBoxStyle,
      headerFormatter: headerCheckBox,
      editor: { type: Type.CHECKBOX, value: "y:n" },
      formatter: checkboxFormat,
      editCellStyle: editCellStyle,
    },

    {
      dataField: "Flag_Sell",
      text: "ขาย",
      align: "center",
      style: fieldStyle,
      headerStyle: headerFlagStyle,
      editorStyle: editorCheckBoxStyle,
      headerFormatter: headerCheckBox,
      editor: editorCheckBox,
      formatter: checkboxFormat,
      editCellStyle: editCellStyle,
    },

    {
      dataField: "Flag_Modality",
      text: "RIS",
      align: "center",
      style: fieldStyle,
      headerStyle: headerFlagStyle,
      editorStyle: editorCheckBoxStyle,
      headerFormatter: headerCheckBox,
      editor: editorCheckBox,
      formatter: checkboxFormat,
      editCellStyle: editCellStyle,
    },

    {
      dataField: "Flag_Service",
      text: "บริการ",
      align: "center",
      style: fieldStyle,
      headerStyle: headerFlagStyle,
      editorStyle: editorCheckBoxStyle,
      headerFormatter: headerCheckBox,
      editor: editorCheckBox,
      formatter: checkboxFormat,
      editCellStyle: editCellStyle,
    },

    {
      dataField: "Flag_Sn",
      text: "S/N",
      align: "center",
      style: fieldStyle,
      headerStyle: headerFlagStyle,
      editorStyle: editorCheckBoxStyle,
      headerFormatter: headerCheckBox,
      editor: editorCheckBox,
      formatter: checkboxFormat,
      editCellStyle: editCellStyle,
    },

    {
      dataField: "Flag_Stock",
      text: "สต็อก",
      align: "center",
      editor: editorCheckBox,
      editorStyle: editorCheckBoxStyle,
      headerFormatter: headerCheckBox,
      editCellStyle: editCellStyle,
      style: fieldStyle,
      formatter: checkboxFormat,
      headerStyle: { ...headerFlagStyle(), width: "50px" },
    },

    {
      dataField: "Flag_Tool",
      text: "เครื่องมือ",
      align: "center",
      editor: editorCheckBox,
      headerFormatter: headerCheckBox,
      editCellStyle: editCellStyle,
      editorStyle: editorCheckBoxStyle,
      style: fieldStyle,
      formatter: checkboxFormat,
      headerStyle: headerFlagStyle,
    },

    {
      dataField: "Flag_InvoiceHide",
      text: "ซ่อนบนบิล",
      align: "center",
      editor: editorCheckBox,
      headerFormatter: headerCheckBox,
      editCellStyle: editCellStyle,
      editorStyle: editorCheckBoxStyle,
      style: fieldStyle,
      formatter: checkboxFormat,
      headerStyle: headerFlagStyle,
    },

    {
      dataField: null,
      text: "",
      headerStyle: headerFlagStyle,
      align: "center",
      editable: false,
      formatter: removeBox,
      headerFormatter: headerBox,
    },
  ];

  return (
    <MyModal
      backdrop="static"
      show={props.showCategory}
      size="xl"
      onHide={() => {
        props.setShowCategory(false);
      }}
    >
      <ModalHeaderBlack closeButton>
        เพิ่ม/แก้ไขประเภทสินค้า/บริการ
      </ModalHeaderBlack>
      <ModalBodyBlack>
        <MainPane>
          <LeftPane>
            {GetCreateTable({
              idFieldName: "pacs_stGoodCateIDudy_id",
              columns,
              data,
              // selectRow,
              // defaultSorted,
              // rowEvents,
              // defaultSorted,
            })}
            {/* <BoostrapTable
              bootstrap4
              keyField="GoodCateID"
              data={data}
              columns={columns}
              striped
              hover
              condensed
              headerClasses="headerWrapper"
              // filter= {filterFactory()}
              rowClasses={"table-next-rows-style"}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                beforeSaveCell: beforeSaveCell,
              })}

              // pagination = {paginationFactory( PageOptions)}
              // rowStyle = {rowStyle2}
              // rowEvents= {rowEvents}
            /> */}
          </LeftPane>

          <RightPane></RightPane>
        </MainPane>
      </ModalBodyBlack>
    </MyModal>
  );
}

const MainPane = styled.div`
  display: flex;
  justify-content: center;
  min-height: 80vh;
  max-height: 80vh;
  overflow-y: scroll;

  /* background-color:red; */
`;

const LeftPane = styled.div``;

const RightPane = styled.div``;
